import { SettingsNav } from '@clearkit/icons';

import { CompanyTeamSettings } from '~/components/profile/CompanyTeamSettings';
import { PageLayout } from '~/components/unified/PageLayout';

export const PageTeamGeneral = () => (
  <PageLayout>
    <PageLayout.Header>
      <PageLayout.Tile>
        <SettingsNav />
      </PageLayout.Tile>
      <PageLayout.Heading>General</PageLayout.Heading>
      <PageLayout.SubHeading>Manage your team settings</PageLayout.SubHeading>
    </PageLayout.Header>
    <PageLayout.Body>
      <PageLayout.Content>
        <CompanyTeamSettings />
      </PageLayout.Content>
    </PageLayout.Body>
  </PageLayout>
);
